import { roleuser, testTypes as testTypesConstants } from '@edulastic/constants'
import _, { omit } from 'lodash'
import {
  getAllTestTypeLabels,
  getAllTestTypesWithBaseType,
} from '../../author/src/utils/testTypes'

const { TEST_TYPES, PREMIUM_TEST_TYPES } = testTypesConstants

export const getAllTestTypesMap = (userTestTypesInternal) => {
  return getAllTestTypeLabels(userTestTypesInternal)
}

export const getNonPremiumTestTypes = (userTestTypesInternal) => {
  return omit(getAllTestTypesMap(userTestTypesInternal), PREMIUM_TEST_TYPES)
}

export const includeCommonOnTestType = (
  availableTestTypes,
  testType,
  allTestTypesInternal,
  userTestTypesInternal
) => {
  if (
    allTestTypesInternal.COMMON.includes(testType) &&
    !(testType in availableTestTypes)
  ) {
    return {
      [`${testType}`]: getAllTestTypeLabels(userTestTypesInternal)[testType],
      ...availableTestTypes,
    }
  }
  return availableTestTypes
}

export const filterTestTypeLabelsForUserRole = (
  role,
  availableTestTypes,
  canSchoolAdminUseDistrictCommon,
  userTestTypesInternal
) => {
  if (
    role === roleuser.SCHOOL_ADMIN &&
    canSchoolAdminUseDistrictCommon === false
  ) {
    const [commonAssessment] = TEST_TYPES.COMMON
    return omit(
      availableTestTypes,
      getAllTestTypesWithBaseType(userTestTypesInternal, [commonAssessment])
    )
  }
  return availableTestTypes
}

export const getAvailableTestTypesForUser = (userDetails = {}) => {
  const {
    isPremium,
    role,
    canSchoolAdminUseDistrictCommon,
    canTeacherAuthorCommonTests = false,
    userTestTypesInternal,
  } = userDetails
  const activeUserTestTypes = _.cloneDeep(userTestTypesInternal)

  Object.values(activeUserTestTypes).forEach(({ title, active, access }) => {
    if (!active || !access) {
      delete activeUserTestTypes[title]
    }
  })
  const availableTestTypes = isPremium
    ? getAllTestTypesMap(activeUserTestTypes)
    : getNonPremiumTestTypes(activeUserTestTypes)
  if (role) {
    const isAdmin = roleuser.DA_SA_ROLE_ARRAY.includes(role)
    return isAdmin
      ? filterTestTypeLabelsForUserRole(
          role,
          availableTestTypes,
          canSchoolAdminUseDistrictCommon,
          activeUserTestTypes
        )
      : canTeacherAuthorCommonTests && role === roleuser.TEACHER
      ? availableTestTypes
      : omit(
          availableTestTypes,
          getAllTestTypesWithBaseType(activeUserTestTypes, TEST_TYPES.COMMON)
        )
  }
  return availableTestTypes
}

export const getProfileKey = (testType, allTestTypesInternal) => {
  for (const [key, value] of Object.entries(allTestTypesInternal)) {
    if (value.includes(testType)) {
      return key.toLowerCase()
    }
  }
}

export const getArrayOfAllTestTypes = (userTestTypesInternal) => {
  const availableTestTypes = getAllTestTypesMap(userTestTypesInternal)
  return Object.entries(availableTestTypes).map(([key, title]) => ({
    key,
    title,
  }))
}

export const getArrayOfRequiredTestTypes = ({
  availableTestTypes,
  excludedTestTypes = [...TEST_TYPES.SURVEY],
  userTestTypesInternal = {},
} = {}) => {
  return (availableTestTypes ?? getArrayOfAllTestTypes(userTestTypesInternal)).filter(
    ({ key }) => !excludedTestTypes.includes(key)
  )
}

export const getArrayOfNonPremiumTestTypes = (userTestTypesInternal) => {
  const availableTestTypes = getNonPremiumTestTypes(userTestTypesInternal)
  return Object.entries(availableTestTypes).map(([key, title]) => ({
    key,
    title,
  }))
}
